import { defineComponent as _defineComponent } from 'vue'
import { HeadingDisplayLoader } from '@/modules/trade/components/HeadingDisplayLoader';
import { SkeletonLoader } from '@warrenbrasil/nebraska-web';

export default /*#__PURE__*/_defineComponent({
  __name: 'PortabilityDetailsLoader',
  setup(__props) {


return { __sfc: true,HeadingDisplayLoader, SkeletonLoader }
}

})